// src/utils/downloadPNG.js

/**
 * 편지 영역을 PNG로 저장
 * @param {React.RefObject} ref - 캡처할 DOM 요소 ref
 * @param {string} animalName - 동물 이름 (파일명 사용)
 */
export const downloadLetterAsPNG = async (ref, animalName = "친구") => {
  const el = ref.current;
  if (!el) return;

  // html2canvas 동적 로드
  if (!window.html2canvas) {
    await new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";
      script.onload = resolve;
      script.onerror = () => reject(new Error("html2canvas 로드 실패"));
      document.head.appendChild(script);
    });
  }

  const canvas = await window.html2canvas(el, {
    scale: 2,           // 고해상도
    useCORS: true,
    allowTaint: true,
    backgroundColor: null,
    logging: false,
  });

  const link = document.createElement("a");
  link.download = `펫말_${animalName}_편지.png`;
  link.href = canvas.toDataURL("image/png");
  link.click();
};
